import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import getTheme from './theme';
import './index.css';

// Create theme with light mode by default
const theme = createTheme(getTheme('light'));

// Suppress ResizeObserver loop limit exceeded error
// This error is harmless but shows an annoying overlay in development
const isResizeObserverError = (msg) =>
  msg === 'ResizeObserver loop completed with undelivered notifications' ||
  msg === 'ResizeObserver loop limit exceeded';

window.addEventListener('error', (e) => {
  if (isResizeObserverError(e.message)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
}, true);

window.addEventListener('unhandledrejection', (e) => {
  if (isResizeObserverError(e.reason?.message)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </MuiThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
